import { Platform } from 'react-native';

export const DEFAULT_ELEVATION = 4;
export const ROUNDED_CORNER = 25;
export const BORDER_RADIUS = 4;

const TOUCH_SIZE = 8;
const TOP_TOUCH_PAD = 8;

/**
 * Dot indicator constant sizes.
 */
export const DOT_INDICATOR_SIZE = 6;
export const DOT_INDICATOR_COUNT = 3;
export const CLOSE_ICON_SIZE = 9;

export const HEADER_HIT_SLOP = {
  bottom: TOUCH_SIZE,
  left: TOUCH_SIZE + TOP_TOUCH_PAD,
  right: TOUCH_SIZE,
  top: TOUCH_SIZE + TOP_TOUCH_PAD,
};

export const makeHitSlop = (size: number) => ({
  bottom: size,
  left: size,
  right: size,
  top: size,
});

const APP_BAR_HEIGHT = Platform.select({
  ios: 44,
  android: 56,
  default: 64,
});
const STATUS_BAR_HEIGHT = Platform.select({
  ios: 20,
  default: 0,
});

export const Header = {
  HEIGHT: APP_BAR_HEIGHT + STATUS_BAR_HEIGHT,
};
